import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { MeshGradient } from "../components/AnimatedBackground";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "../i18n";

export function Impressum() {
  const { t, lang, switchLanguage } = useLanguage();

  return (
    <div className="relative min-h-screen">
      <div className="noise-overlay" />
      <MeshGradient />
      <Navbar currentPage="legal" />

      <main className="relative z-10 pt-32 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          {/* Top bar: back + language switch */}
          <div className="flex items-center justify-between mb-8">
            <a
              href="/"
              className="inline-flex items-center gap-2 text-zinc-400 hover:text-white transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              {t.backToHome}
            </a>
            <button
              onClick={() => switchLanguage(lang === "de" ? "en" : "de")}
              className="text-sm text-zinc-500 hover:text-white transition-colors border border-white/10 rounded px-2 py-1"
            >
              {lang === "de" ? "English" : "Deutsch"}
            </button>
          </div>

          {/* Page Header */}
          <div className="mb-12">
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">{t.impressum.title}</h1>
            <p className="text-zinc-400">{t.impressum.subtitle}</p>
          </div>

          {/* Content */}
          <div className="space-y-8">
            {/* § 5 TMG */}
            <section className="glass-card rounded-xl p-6">
              <h2 className="text-xl font-semibold text-white mb-4">{t.impressum.section1Title}</h2>
              <div className="space-y-1 text-zinc-400">
                <p>{t.impressum.name}</p>
                <p>{t.impressum.address1}</p>
                <p>{t.impressum.address2}</p>
                <p>{t.impressum.address3}</p>
                <p>{t.impressum.address4}</p>
              </div>
            </section>

            {/* Contact */}
            <section className="glass-card rounded-xl p-6">
              <h2 className="text-xl font-semibold text-white mb-4">{t.impressum.contactTitle}</h2>
              <div className="space-y-2 text-zinc-400">
                <p>
                  {t.impressum.emailLabel}{" "}
                  <a href={`mailto:${t.impressum.email}`} className="text-emerald-400 hover:text-emerald-300 transition-colors">
                    {t.impressum.email}
                  </a>
                </p>
                <p>
                  {t.impressum.websiteLabel}{" "}
                  <a href={t.impressum.website} target="_blank" rel="noopener noreferrer" className="text-emerald-400 hover:text-emerald-300 transition-colors">
                    {t.impressum.website}
                  </a>
                </p>
              </div>
            </section>

            {/* Verantwortlich für den Inhalt — § 18 Abs. 2 MStV */}
            <section className="glass-card rounded-xl p-6">
              <h2 className="text-xl font-semibold text-white mb-4">{t.impressum.verantwortlichTitle}</h2>
              <div className="space-y-3 text-zinc-400">
                <p>{t.impressum.verantwortlichText}</p>
                <p>{t.impressum.name}</p>
                <p>{t.impressum.address1}</p>
                <p>{t.impressum.address2}</p>
                <p>{t.impressum.address3}</p>
                <p>{t.impressum.address4}</p>
              </div>
            </section>

            {/* USt-ID */}
            <section className="glass-card rounded-xl p-6">
              <h2 className="text-xl font-semibold text-white mb-4">{t.impressum.ustIdTitle}</h2>
              <p className="text-zinc-400">{t.impressum.ustIdText}</p>
            </section>

            {/* Streitschlichtung */}
            <section className="glass-card rounded-xl p-6">
              <h2 className="text-xl font-semibold text-white mb-4">{t.impressum.streitTitle}</h2>
              <p className="text-zinc-400 mb-4">
                {t.impressum.streitP1}
                <a href={t.impressum.streitLink} target="_blank" rel="noopener noreferrer" className="text-emerald-400 hover:text-emerald-300 transition-colors">
                  {t.impressum.streitLink}
                </a>
              </p>
              <p className="text-zinc-400">{t.impressum.streitP2}</p>
            </section>

            {/* Haftung für Inhalte */}
            <section className="glass-card rounded-xl p-6">
              <h2 className="text-xl font-semibold text-white mb-4">{t.impressum.haftContentTitle}</h2>
              <p className="text-zinc-400 mb-4">{t.impressum.haftContentP1}</p>
              <p className="text-zinc-400">{t.impressum.haftContentP2}</p>
            </section>

            {/* Haftung für Links */}
            <section className="glass-card rounded-xl p-6">
              <h2 className="text-xl font-semibold text-white mb-4">{t.impressum.haftLinksTitle}</h2>
              <p className="text-zinc-400 mb-4">{t.impressum.haftLinksP1}</p>
              <p className="text-zinc-400">{t.impressum.haftLinksP2}</p>
            </section>

            {/* Urheberrecht */}
            <section className="glass-card rounded-xl p-6">
              <h2 className="text-xl font-semibold text-white mb-4">{t.impressum.urheberTitle}</h2>
              <p className="text-zinc-400 mb-4">{t.impressum.urheberP1}</p>
              <p className="text-zinc-400">{t.impressum.urheberP2}</p>
            </section>
          </div>

          {/* Last updated */}
          <div className="mt-12 pt-8 border-t border-white/10">
            <p className="text-sm text-zinc-500">Last updated: April 2026</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
